import { Collections } from 'Collections';
import { FirebaseUtils } from 'firebaseUtils/FirebaseUtils';
import { AnalyticsEvent } from 'models/AnalyticsEvent';
import { IdMap } from 'models/IdMap';
import { PriceField } from 'models/PriceField';
import { toIdMap } from 'Util/toIdMap';
import React, { useContext, useMemo } from 'react';
import { useOrg } from './OrgProvider';
import { Snacbars } from './Snacbars';


type Props = {
    children: React.ReactNode
}

const PRICE_FIELDS_CONTEXT = React.createContext<[priceFields: IdMap<PriceField> | null, loading: boolean]>([null, true])

export function usePriceFiels() {
    return useContext(PRICE_FIELDS_CONTEXT)
}

export function PriceFieldProvider({ children }: Props) {
    const [org, loadingOrg] = useOrg()
    const [priceFields, loadingPriceFields, error] = FirebaseUtils.useCollectionData<PriceField>(
        true,
        Collections.PRICE_FIELDS,
        AnalyticsEvent.GET_PRICE_FIELDS_ERROR,
        {},
        (query, path) => (
            org && query.where(path.data.org.id, '==', org?.data.id).limit(2000)
        ))

    const loading = loadingOrg || loadingPriceFields

    const map = useMemo(() => {
        return priceFields ? toIdMap(priceFields.map(p => p.data)) : null
    }, [priceFields])

    return (
        <PRICE_FIELDS_CONTEXT.Provider value={[map, loading]}>
            <Snacbars error={error?.message} />
            {children}
        </PRICE_FIELDS_CONTEXT.Provider>
    )
}
